"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Heart, UserCheck, Users, ArrowRight } from "lucide-react";
const keyPoints = [{
  icon: UserCheck,
  title: "Afgestemd op uw situatie",
  description: "Zorg die naadloos aansluit bij uw persoonlijke wensen en dagelijkse behoeften."
}, {
  icon: Heart,
  title: "Respect voor uw achtergrond",
  description: "Volledige aandacht en respect voor uw leefwijze, religie en cultuur."
}, {
  icon: Users,
  title: "Vertrouwde gezichten",
  description: "Wij werken waar mogelijk met vaste, gediplomeerde zorgverleners voor optimale continuïteit."
}];
export default function PassendeZorgInDeThuissituatie() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="passende-zorg-in-de-thuissituatie" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary mb-6">
              Persoonsgerichte aanpak
            </div>
            
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl mb-6">
              Passende zorg in de thuissituatie
            </h2>
            
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              Iedere cliënt is uniek. Bij CuraNova Zorg geloven we dat goede zorg verder gaat dan alleen medische of praktische ondersteuning. Het draait om u als mens. Daarom staat een persoonsgerichte aanpak bij ons altijd centraal.
            </p>
            
            <div className="w-full space-y-6 mb-8 mt-4">
              {keyPoints.map((point, i) => {
              const Icon = point.icon;
              return <div key={i} data-index={i} className="flex items-start gap-4">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-secondary text-primary shadow-sm">
                      <Icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-foreground">
                        {point.title}
                      </h3>
                      <p className="mt-1 text-sm text-muted-foreground leading-relaxed">
                        {point.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            <Button asChild size="lg" className="mt-2 rounded-full px-8">
              <Link to="/ContactPage">
                Bespreek uw situatie
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute -inset-4 rounded-[3rem] bg-secondary/50 transform rotate-3 scale-105 -z-10 transition-transform duration-700 hover:rotate-6"></div>
            <div className="absolute -inset-4 rounded-[3rem] bg-primary/5 transform -rotate-2 scale-105 -z-10"></div>
            
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-[2.5rem] shadow-2xl shadow-primary/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576260/img/curanova_persoonsgerichte_zorg_thuis.png" alt="Zorgverlener van CuraNova Zorg in gesprek met een cliënt in de thuissituatie" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 md:-left-10 bg-card p-4 rounded-2xl shadow-xl border border-border/50 flex items-center gap-4 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-500">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-accent text-accent-foreground">
                <Users className="h-5 w-5" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground">Vaste zorgverleners</p>
                <p className="text-xs text-muted-foreground">Voor uw vertrouwen</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}